<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/bank-account/new" class="btn btn-info"><i class="fa fa-plus"></i> Adicionar
                    conta</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Nome</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Asaas"
                                v-model="advanced_search_input.name">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">Banco</label>
                            <multiselect v-model="bank_multiselect" :options="banks_options"
                                :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                @select="handleSelectBank">

                                <template #noResult>
                                    Nenhum banco encontrado.
                                </template>
                            </multiselect>
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">Agência</label>
                            <input type="text" id="agency" class="form-control" placeholder="Ex: 0001"
                                v-model="advanced_search_input.agency">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-4 col-sm-12">
                            <label for="">Conta</label>
                            <input type="text" id="account" class="form-control" placeholder="Ex: 123456-7"
                                v-model="advanced_search_input.account">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i>
                                Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i>
                                Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Contas bancárias
                              <br><small><span
                                    v-if="total_itens > 0">Total registros encontrados: {{ formatDecimal(total_itens) }}</span></small>
                        </h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Banco</th>
                                        <th>Agência</th>
                                        <th>Conta</th>
                                        <th>Tipo da conta</th>
                                        <th>Integração</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(bank) in banks_saved" :key="bank.id">
                                        <td>{{ bank.name }} </td>
                                        <td>{{ bank.bank ? bank.bank : '-' }} </td>
                                        <td>{{ bank.agency ? bank.agency : '-' }} </td>
                                        <td>{{ bank.account ? bank.account : '-' }} </td>
                                        <td>{{ bank.type_account ? bank.type_account : '-' }} </td>
                                        <td>
                                            <span class="badge badge-success" v-if="bank.gateway != ''"><i
                                                    class="fa fa-check"></i> Integrado</span>
                                            <span class="badge badge-danger" v-else><i class="fa fa-times"></i> Não
                                                integrado</span>
                                        </td>

                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <router-link class="dropdown-item" :to="{
                                                        name: 'bank_account_edit',
                                                        params: { id: bank.id }
                                                    }">Detalhes</router-link>
                                                    <router-link v-if="gatewayAvailable(bank.bank)"
                                                        class="dropdown-item" :to="{
                                                            name: 'bank_account_gateway_edit',
                                                            params: { id: bank.id }
                                                        }">Integração bancária</router-link>
                                                    <button class="dropdown-item" v-if="gatewayAvailable(bank.bank)"
                                                        @click="deleteGateway(bank.id)">Excluir integração gateway</button>
                                                    <button class="dropdown-item"
                                                        @click="deleteBankAccount(bank.id)">Excluir conta</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="banks_saved.length > 0 && page > 1">
                                        <td colspan="8" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="banks_saved.length <= 0">
                                        <td colspan="8" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadBank } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'

export default {
    components: { Loading, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            bank_multiselect: '',
            banks_options: [],
            banks: {},
            banks_saved: [],
            gateways_available: [],
            page: 1,
            last_page: 1,
            total_itens: 0
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    mounted() {
        const response_banks = this.getBank();
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({
                title: item.fullName,
                value: 'Código: ' + item.code + ' / ' + 'Banco: ' + capitalize(item.name)
            }));
        });
        this.loadData();

    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.banks_saved = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.banks_saved = {};
            this.advanced_search_input = {};
            this.bank_multiselect = '';
            this.loadData();
        },
        bankWithLang({ value }) {
            return value;
        },
        handleSelectBank(option) {
            this.advanced_search_input.bank = option.value;
        },

        async getBank() {
            this.isLoading = true;
            const response = await loadBank().then((response) => {
                let banks = response;
                banks.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    return 0;
                });
                this.banks = banks;

                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });

            return response;
        },
        formatDecimal(number) {
           return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/bank-account', {
                params: {
                    'name': this.advanced_search_input.name,
                    'bank': this.advanced_search_input.bank,
                    'agency': this.advanced_search_input.agency,
                    'account': this.advanced_search_input.account,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.banks_saved = response.data.data;
                    } else {
                        this.banks_saved = this.banks_saved.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                    this.gateways_available = response.data.gateways_available;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        gatewayAvailable(bank) {
            let available = false
            this.gateways_available.forEach(gateway => {
                if (bank === gateway.name) {
                    available = true;
                }
            });

            return available;
        },

        deleteBankAccount(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar a a conta bancária? Nota: uma vez removida a conta, não será mais possível recuperar os dados atrelados a esta conta.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/bank-account/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Conta bancária excluída com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
         deleteGateway(id) {
            this.$confirm(
                {
                    message: 'Deseja remover a integração com o gatreway? Nota: uma vez removido, não será mais possível registrar boletos e PIX via BACEN.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/bank-account/' + id+'/delete-gateway')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Integração gateway excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }

    },
}
</script>

<style></style>